import mixpanel from 'mixpanel-browser'
import { logger } from '@moonpig/web-core-monitoring'

export const initMixpanel = (mixpanelRecordingPercent: number) => {
  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN

  if (!MIXPANEL_TOKEN) {
    logger.warning('Mixpanel token is missing! Check your .env file.')
    return
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: mixpanelRecordingPercent,
  })
}

export const trackPageView = (url: string) => {
  mixpanel.track('Page View', { url })
}
